import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", {
  class: "alert alert-success",
  "data-cy": "PayPortal.Success.Alert"
}, "You have acquired a license for this content.", -1)
const _hoisted_2 = { "data-cy": "PayPortal.Success.Heading" }
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { "data-cy": "PayPortal.Success.Text" }, "Success! You're now ready to access your content.", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)




export default _defineComponent({
  expose: [],
  props: {
    className: { type: String, required: true }
  } as unknown as undefined,
  emits: ['return-to-mobius'],
  setup(__props: {
	className: string
}) {







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("h1", _hoisted_2, _toDisplayString(__props.className), 1),
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('return-to-mobius'))),
      class: "btn btn-lg btn-primary",
      "data-cy": "PayPortal.Success.ReturnToActivityButton"
    }, "Return to activity")
  ]))
}
}

})